import RangeSliderSdk from '../components/RangeSlider/corvid/RangeSlider.corvid';


const RangeSlider = {
  sdk: RangeSliderSdk
};


export const components = {
  ['RangeSlider']: RangeSlider
};

